import { loadView } from './functions';

export const FrontendChildren = {
  children: [
    {
      path: '/',
      name: 'Home',
      component: loadView('Frontend/Home'),
      meta: {
        title: 'Service Finder - Facilities Near You',
        description:
          'Find health and support facilities near you. Browse categories, view details, and get directions.',
        ogImage: '/img/location.png',
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: loadView('Frontend/Login'),
      meta: {
        title: 'Sign in - Service Finder',
        description: 'Sign in to your Service Finder account to save reviews and preferences.',
        ogImage: '/img/location.png',
      },
    },
    {
      path: '/register-confirm',
      name: 'Confirm Email',
      component: loadView('Frontend/RegisterConfirm'),
      meta: {
        title: 'Confirm your email - Service Finder',
        description: 'Finish setting up your Service Finder account by confirming your email.',
        ogImage: '/img/location.png',
      },
    },
    {
      path: '/password-reset/:id',
      name: 'Password Reset',
      component: loadView('Frontend/PasswordReset'),
      meta: {
        title: 'Reset your password - Service Finder',
        description: 'Reset your Service Finder account password securely.',
        ogImage: '/img/location.png',
      },
    },
  ],
};
